exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "social-security-modal .modal-dialog{max-height:410px;max-width:520px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/social-security.module/components/socialSecurityModal/socialSecurityModal.scss
// module id = 2320
// module chunks = 0